import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import { Link } from 'react-router-dom';
import { CardLink } from 'react-bootstrap';

const Employerdashboard= () => {
  return (
    <Container fluid>
  
      <Container className='mt-3'>
   
      <Row>
        <Col><h6 className='fw-bold pt-2'>Dashboard</h6></Col>
        
      </Row>
        <Row className='mt-3'>
          <Col sm={12} md={12} lg={4}>
         
          <Card className='rounded-0 shadow-sm' style={{minHeight:'350px'}}>
      <Card.Header className='card-title'>User Management</Card.Header>
      <Card.Body>
      <Card.Text>
      <ListGroup.Item
        as="li"
        className="d-flex justify-content-between align-items-start border-0 p-0"
      >  <Card.Link as={Link} to="/Agents"><div className="ms-2 me-auto">
          <div className="fw-bold card-text-primary">Agents</div>
          <span className='text-muted'>View & manage all Agents.</span>
        </div></Card.Link>
        </ListGroup.Item>
        <hr></hr>
        <ListGroup.Item
        as="li"
        className="d-flex justify-content-between align-items-start border-0 p-0"
      > <Card.Link as={Link} to="/Customers"><div className="ms-2 me-auto">
          <div className="fw-bold card-text-primary">Customers</div>
          <span className='text-muted'> View & manage all Customers.</span>
        </div>
        </Card.Link>
        </ListGroup.Item>
        <hr></hr>
        <ListGroup.Item
        as="li"
        className="d-flex justify-content-between align-items-start border-0 p-0"
      > <Card.Link as={Link} to="/"><div className="ms-2 me-auto">
          <div className="fw-bold card-text-primary">Staff</div>
          <span className='text-muted'> View & manage all Staff.</span>
        </div>
        </Card.Link>
        </ListGroup.Item>
        <hr></hr>
        <ListGroup.Item
        as="li"
        className="d-flex justify-content-between align-items-start border-0 p-0"
      > <Card.Link as={Link} to="/"><div className="ms-2 me-auto">
          <div className="fw-bold card-text-primary">Carriers</div>
          <span className='text-muted'>View & manage all Carriers.</span> 
        </div>
        </Card.Link>
        </ListGroup.Item>
              
        </Card.Text>
        </Card.Body>
    </Card>
          </Col>
          <Col sm={12} md={12} lg={4}>
          <Card className='rounded-0 shadow-sm' style={{minHeight:'350px'}}>
      <Card.Header className='card-title'>RFQ</Card.Header>
      <Card.Body>
      <Card.Text>
      <ListGroup.Item
        as="li"
        className="d-flex justify-content-between align-items-start border-0 p-0"
      >  <Card.Link as={Link} to="/QuotesforIndividual"><div className="ms-2 me-auto">
          <div className="fw-bold card-text-primary">Quotes for Individual          </div>
          <span className='text-muted'>View & Manage All Quote for Individual</span>
        </div></Card.Link>
        </ListGroup.Item>
        <hr></hr>
        <ListGroup.Item
        as="li"
        className="d-flex justify-content-between align-items-start border-0 p-0"
      > <Card.Link as={Link} to="/QuotesforBusiness"><div className="ms-2 me-auto">
          <div className="fw-bold card-text-primary">Quotes for Business</div>
          <span className='text-muted'>  View & Manage All Quote for Business</span>
        </div>
        </Card.Link>
        </ListGroup.Item>
        <hr></hr>
        <ListGroup.Item
        as="li"
        className="d-flex justify-content-between align-items-start border-0 p-0"
      > <Card.Link as={Link} to="/QuotesforAnnuity"><div className="ms-2 me-auto">
          <div className="fw-bold card-text-primary">Quotes for Annuity</div>
          <span className='text-muted'> View & Manage All Quote for Annuity</span>
        </div>
        </Card.Link>
        </ListGroup.Item>
          
     
       
        </Card.Text>
        </Card.Body>
    </Card>
          </Col>
          <Col sm={12} md={12} lg={4}>
          <Card className='rounded-0 shadow-sm' style={{minHeight:'350px'}}>
      <Card.Header className='card-title'>Policy Management</Card.Header>
      <Card.Body>
      <Card.Text>
      <ListGroup.Item
        as="li"
        className="d-flex justify-content-between align-items-start border-0 p-0"
      >  <Card.Link as={Link} to="/ApprovedPolicySubmissions"><div className="ms-2 me-auto">
          <div className="fw-bold card-text-primary">Approved  Policy Submissions</div>
          <span className='text-muted'>View & Manage Approved Policy Submissions</span>
        </div></Card.Link>
        </ListGroup.Item>
        <hr></hr>
        <ListGroup.Item
        as="li"
        className="d-flex justify-content-between align-items-start border-0 p-0"
      > <Card.Link as={Link} to="/RejectPolicySubmissions"><div className="ms-2 me-auto">
          <div className="fw-bold card-text-primary">Reject  Policy Submissions</div>
          <span className='text-muted'> View & Manage Reject Policy Submissions</span>
        </div>
        </Card.Link>
        </ListGroup.Item>
        <hr></hr>
        <ListGroup.Item
        as="li"
        className="d-flex justify-content-between align-items-start border-0 p-0"
      > <Card.Link as={Link} to="/ModifyPolicySubmissions"><div className="ms-2 me-auto">
          <div className="fw-bold card-text-primary">Modify Policy Submissions</div>
          <span className='text-muted'>  View & Manage Modify Policy Submissions</span>
        </div>
        </Card.Link>
        </ListGroup.Item>
        <hr></hr>
        <ListGroup.Item
        as="li"
        className="d-flex justify-content-between align-items-start border-0 p-0"
      > <Card.Link as={Link} to="/RenewalsandCancellationspolicies"><div className="ms-2 me-auto">
          <div className="fw-bold card-text-primary">Renewals and Cancellations policies.</div>
          <span className='text-muted'>  View & Manage Renewals and Cancellations policies</span>
        </div>
        </Card.Link>
        </ListGroup.Item>
       
        </Card.Text>
        </Card.Body>
    </Card>
          </Col>
        </Row>
       <Row className='mt-4'>               
       
          <Col sm={12} md={12} lg={4}>
         
         <Card className='rounded-0 shadow-sm mt-4'>
         <Card.Header className='card-title'>
      <Row>
        <Col>
        <div className=' d-flex justify-content-start'> Insights and Reports </div>  
        </Col>
        <Col>
        <div class="dropdown d-flex justify-content-end">

 
</div>
        </Col>
      </Row>
      
    
      </Card.Header>
     <Card.Body>
     <Card.Text>
     <ListGroup.Item
       as="li"
       className="d-flex justify-content-between align-items-start border-0 p-0"
     >  <Card.Link as={Link} to="/CustomersInsights"><div className="ms-2 me-auto">
         <div className="fw-bold card-text-primary">Customers</div>
         <span className='text-muted'>View Total Customers Insights.</span>
       </div></Card.Link>
       </ListGroup.Item>
       <hr></hr>
       <ListGroup.Item
       as="li"
       className="d-flex justify-content-between align-items-start border-0 p-0"
     >  <Card.Link as={Link} to="/AgentsInsights"><div className="ms-2 me-auto">
         <div className="fw-bold card-text-primary">Agents</div>
         <span className='text-muted'>View Total Agents Insights.</span>
       </div></Card.Link>
       </ListGroup.Item>
       <hr></hr>
       <ListGroup.Item
       as="li"
       className="d-flex justify-content-between align-items-start border-0 p-0"
     > <Card.Link href="#"><div className="ms-2 me-auto">
         <div className="fw-bold card-text-primary">Sales</div>
         <span className='text-muted'>  View and Sales Insights.</span>
       </div>
       </Card.Link>
       </ListGroup.Item>
       <hr></hr>
       <ListGroup.Item
       as="li"
       className="d-flex justify-content-between align-items-start border-0 p-0"
     > <Card.Link href="#"><div className="ms-2 me-auto">
         <div className="fw-bold card-text-primary">Compliance</div>
         <span className='text-muted'>  View Compliance Insights.</span>
       </div>
       </Card.Link>
       </ListGroup.Item>
       </Card.Text>
       </Card.Body>
   </Card>
         </Col>
     <Col sm={12} md={12} lg={4}>
     <Card className='rounded-0 shadow-sm mt-4'>
     <Card.Header className='card-title'>
      <Row>
        <Col>
        <div className=' d-flex justify-content-start'>Request a call   </div>  
        </Col>
        <Col>
        <div class="dropdown d-flex justify-content-end">
  <button class="btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
    <i class="bi bi-three-dots"></i>
  </button>
  <ul class="dropdown-menu">
    <li><CardLink class="dropdown-item" as={Link} to="/Requestacall">View all</CardLink></li>
     </ul>
</div>
        </Col>
      </Row>
      
    
      </Card.Header>
     <Card.Body>
     <Card.Text>
     <ListGroup.Item
       as="li"
       className="d-flex justify-content-between align-items-start border-0 p-0"
     >  <div className="ms-2 me-auto">
         <div className="fw-bold card-text-primary">William</div>
         <span className='text-muted'>I am interested in taking life insurance. I would like to know more 
         information.</span>

      <Row>
        <Col sm={6}>
        <i class="bi bi-telephone-outbound"></i> 415-295-1112
        </Col>
        <Col  sm={6}>
        <i class="bi bi-envelope"></i> william@outlook.com
        </Col>
        <Col sm={6}>
       <span className='fw-bold'>Date : </span>21 Oct, 2024
        </Col>
        <Col  sm={6}>
        <span className='fw-bold'> Time : </span>11:00  AM
        </Col>
      </Row>
       </div>
       </ListGroup.Item>
       <hr></hr>
       <ListGroup.Item
       as="li"
       className="d-flex justify-content-between align-items-start border-0 p-0"
     >  <div className="ms-2 me-auto">
         <div className="fw-bold card-text-primary">William</div>
         <span className='text-muted'>I am interested in taking life insurance. I would like to know more 
         information.</span>

      <Row>
        <Col sm={6}>
        <i class="bi bi-telephone-outbound"></i> 415-295-1112
        </Col>
        <Col  sm={6}>
        <i class="bi bi-envelope"></i> william@outlook.com
        </Col>
        <Col sm={6}>
       <span className='fw-bold'>Date : </span>21 Oct, 2024
        </Col>
        <Col  sm={6}>
        <span className='fw-bold'> Time : </span>11:00  AM
        </Col>
      </Row>
       </div>
       </ListGroup.Item>
       <hr></hr>
       <ListGroup.Item
       as="li"
       className="d-flex justify-content-between align-items-start border-0 p-0"
     >  <div className="ms-2 me-auto">
         <div className="fw-bold card-text-primary">William</div>
         <span className='text-muted'>I am interested in taking life insurance. I would like to know more 
         information.</span>

      <Row>
        <Col sm={6}>
        <i class="bi bi-telephone-outbound"></i> 415-295-1112
        </Col>
        <Col  sm={6}>
        <i class="bi bi-envelope"></i> william@outlook.com
        </Col>
        <Col sm={6}>
       <span className='fw-bold'>Date : </span>21 Oct, 2024
        </Col>
        <Col  sm={6}>
        <span className='fw-bold'> Time : </span>11:00  AM
        </Col>
      </Row>
       </div>
       </ListGroup.Item>
      
       
              
       </Card.Text>
       </Card.Body>
   </Card>
         </Col>
         <Col sm={12} md={12} lg={4}>
     <Card className='rounded-0 shadow-sm mt-4'>
     <Card.Header className='card-title'>
      <Row>
        <Col>
        <div className=' d-flex justify-content-start'>Appointments   </div>  
        </Col>
        <Col>
        <div class="dropdown d-flex justify-content-end">
  <button class="btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
    <i class="bi bi-three-dots"></i>
  </button>
  <ul class="dropdown-menu">
    <li><CardLink class="dropdown-item"  as={Link} to="/Appointments">View all</CardLink></li>
     </ul>
</div>
        </Col>
      </Row>
      
    
      </Card.Header>
      
     <Card.Body>
     <Card.Text>
     <ListGroup.Item
       as="li"
       className="d-flex justify-content-between align-items-start"
     >  <div className="ms-2 me-auto">
         <div className="fw-bold card-text-primary"><i class="bi bi-calendar-week"></i> William</div>
         <span className='text-muted'>Appointment For Home Insurance</span>
         <Row>
       
        <Col sm={6}>
       <span className='fw-bold'>Date : </span>21 Oct, 2024
        </Col>
        <Col  sm={6}>
        <span className='fw-bold'> Time : </span>11:00  AM
        </Col>
      </Row>
       </div>
       </ListGroup.Item>
       <hr></hr>
       <ListGroup.Item
       as="li"
       className="d-flex justify-content-between align-items-start"
     >  <div className="ms-2 me-auto">
         <div className="fw-bold card-text-primary"><i class="bi bi-calendar-week"></i> William</div>
         <span className='text-muted'>Appointment For Home Insurance</span>
         <Row>
       
        <Col sm={6}>
       <span className='fw-bold'>Date : </span>21 Oct, 2024
        </Col>
        <Col  sm={6}>
        <span className='fw-bold'> Time : </span>11:00  AM
        </Col>
      </Row>
       </div>
       </ListGroup.Item>
       <hr></hr>
       <ListGroup.Item
       as="li"
       className="d-flex justify-content-between align-items-start"
     >  <div className="ms-2 me-auto">
         <div className="fw-bold card-text-primary"><i class="bi bi-calendar-week"></i> William</div>
         <span className='text-muted'>Appointment For Home Insurance</span>
         <Row>
       
        <Col sm={6}>
       <span className='fw-bold'>Date : </span>21 Oct, 2024
        </Col>
        <Col  sm={6}>
        <span className='fw-bold'> Time : </span>11:00  AM
        </Col>
      </Row>
       </div>
       </ListGroup.Item>     
       </Card.Text>
       </Card.Body>
   </Card>
         </Col>
          
         
        </Row>
  <div class="offcanvas offcanvas-end" data-bs-scroll="true" data-bs-backdrop="false" tabindex="-1" id="offcanvasScrolling" aria-labelledby="offcanvasScrollingLabel">
  <div class="offcanvas-header">
    <h6 class="offcanvas-title fw-bold" id="offcanvasScrollingLabel">Add Widgets</h6>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
  
                         <div>
      <Card className='rounded-0 shadow-sm'>
      <Card.Header className='card-title'>Events</Card.Header>
      <Card.Body>
      <Card.Text>
      <ListGroup.Item
        as="li"
        className="d-flex justify-content-between align-items-start"
      >  <Card.Link href="#"><div className="ms-2 me-auto">
          <div className="fw-bold">
            <Row>
            <Col sm={12} md={12} lg={3}>
            <h2><i class="bi bi-calendar-date text-dark"></i></h2>
            </Col>
            <Col sm={12} md={12} lg={9}>
            <span className='text-muted'>Quickly view your latest events.</span>
            </Col>
            </Row>
         </div>
         </div>
         </Card.Link>
        </ListGroup.Item>
        </Card.Text>
        </Card.Body>
    </Card> 


    <Card className='rounded-0 shadow-sm mt-1'>
      <Card.Header className='card-title'>News</Card.Header>
      <Card.Body>
      <Card.Text>
      <ListGroup.Item
        as="li"
        className="d-flex justify-content-between align-items-start"
      >  <Card.Link href="#"><div className="ms-2 me-auto">
          <div className="fw-bold">
            <Row>
            <Col sm={12} md={12} lg={3}>
            <h2><i class="bi bi-newspaper text-dark"></i></h2>
            </Col>
            <Col sm={12} md={12} lg={9}>
            <span className='text-muted'>Quickly view your latest news.</span>
            </Col>
            </Row>
         </div>
         </div>
         </Card.Link>
        </ListGroup.Item>
        </Card.Text>
        </Card.Body>
    </Card> 

    <Card className='rounded-0 shadow-sm mt-1'>
      <Card.Header className='card-title'>Timesheets</Card.Header>
      <Card.Body>
      <Card.Text>
      <ListGroup.Item
        as="li"
        className="d-flex justify-content-between align-items-start"
      >  <Card.Link href="#"><div className="ms-2 me-auto">
          <div className="fw-bold">
            <Row>
            <Col sm={12} md={12} lg={3}>
            <h2><i class="bi bi-card-list text-dark"></i></h2>
            </Col>
            <Col sm={12} md={12} lg={9}>
            <span className='text-muted'>Quickly view your latest timesheets.</span>
            </Col>
            </Row>
         </div>
         </div>
         </Card.Link>
        </ListGroup.Item>
        </Card.Text>
        </Card.Body>
    </Card> 

    

   
    
                        </div>
                        
                  
           
           
       
  </div>
</div>
        
      </Container>
    </Container>
  );
}

export default Employerdashboard